/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import calculateLayoutTreeNodePositions from 'layout-dnd-utils/nodePositions/calculateLayoutTreeNodePositions';
import calculateGridLayoutTreeNodePositions from 'layout-dnd-utils/nodePositions/calculateGridLayoutTreeNodePositions';
import { GLOBAL_GROUPS_CONFIG, GLOBAL_PARTIALS_CONFIG, HEADER_INFO_CONFIG, FOOTER_INFO_CONFIG, STATIC_MODULES_CONFIG, FLEX_COLUMN_MODULES_CONFIG, LAYOUT_SECTIONS_CONFIG, POST_BODY_MODULES_CONFIG, NESTED_MODULES_IN_RTE_CONFIG, GRID_LAYOUTS_NODE_POSITION_CONFIG } from 'InpageEditorUI/lib/layoutSection/constants';
import { getModuleElement } from 'InpageEditorUI/lib/dom';
import { buildGetElementBounds } from 'layout-dnd-utils/dom/bounds';
import { getTallestElementHeight } from 'layout-dnd-utils/dom/getTallestElementHeight';
import { buildGlobalGroupSelector, buildGlobalPartialSelector } from 'layout-dnd-utils/dom/globalSelectors';
import { getLayoutTreeElements } from 'layout-dnd-utils/nodePositions/nodePositionLayoutTreeUtils';
import { getGridLayoutTreeElement } from 'layout-dnd-utils/nodePositions/nodePositionGridLayoutTreeUtils';
import { isImmutable } from 'ContentEditorUI/utils/dataHelpers';
import { memoize } from 'underscore';
let delegatedElementsByNameOrPath = {};
export const setDelegatedElementsForConfigToUse = delegatedBoundsElementsByNameOrPath => {
  delegatedElementsByNameOrPath = delegatedBoundsElementsByNameOrPath;
};
let viewportBoundsForCurrentPass;
export const setViewportBoundsForConfigToUse = viewportBounds => {
  viewportBoundsForCurrentPass = viewportBounds;
};
const hasDelegatedBounds = nameOrPath => {
  return delegatedElementsByNameOrPath.hasOwnProperty(nameOrPath);
};
const getDelegatedBounds = nameOrPath => {
  return delegatedElementsByNameOrPath[nameOrPath];
};
const getElementBoundsWithScrollAndPositionInfo = buildGetElementBounds({
  applyScrollOffset: true,
  applyPositionInfo: true
});
const getElementBoundsWithScrollOffset = buildGetElementBounds({
  applyScrollOffset: true
});
const getElementBoundsWithScrollAndOffsetAndPositionInfo = buildGetElementBounds({
  applyScrollOffset: true,
  applyPositionInfo: true,
  applyOffset: true
});
const getStaticOrFlexColumnElement = item => {
  let element;
  if (hasDelegatedBounds(item.get('name'))) {
    element = getDelegatedBounds(item.get('name'));
  } else {
    element = getModuleElement(item);
  }
  return element ? [element] : [];
};
const elementHasInlineHubDBField = element => {
  return Boolean(element.querySelector('[data-hs-token^="hubdb.dynamic_page_hubdb_row"]'));
};
const elementHasStructuredContentDataToken = item => {
  const moduleDataTokens = item.getIn(['body', 'data_tokens']);
  if (!moduleDataTokens) {
    return false;
  }
  if (isImmutable(moduleDataTokens)) {
    return Boolean(moduleDataTokens.find(dataToken => dataToken.startsWith('dynamic_page_hubdb_row.')));
  }
  return Object.values(moduleDataTokens).some(dataToken => dataToken.startsWith('dynamic_page_hubdb_row.'));
};
const getStaticOrFlexColumnElementThatContainsStructuredContent = item => {
  const elementArray = getStaticOrFlexColumnElement(item);
  if (elementArray.length === 0) {
    return elementArray;
  }
  const element = elementArray[0];
  return elementHasInlineHubDBField(element) || elementHasStructuredContentDataToken(item) ? elementArray : [];
};
export const postBodyModuleNodePositionConfig = {
  name: POST_BODY_MODULES_CONFIG,
  getCustomFields: ({
    /* element, index, */item
  }) => ({
    depth: 0,
    id: item.get('name'),
    isModule: true,
    isStaticModule: false,
    isPostBodyModule: true,
    hasDelegatedBounds: hasDelegatedBounds(item.get('name'))
  }),
  getElementBounds: getElementBoundsWithScrollAndOffsetAndPositionInfo,
  getElements: getStaticOrFlexColumnElement,
  getListFromNodeData: ({
    allPostBodyModules
  }) => {
    return allPostBodyModules || [];
  }
};
export const nestedModulesInRichTextNodePositionConfig = {
  name: NESTED_MODULES_IN_RTE_CONFIG,
  getCustomFields: ({
    /* element, index, */item
  }) => ({
    depth: 0,
    id: item.get('name'),
    isModule: true,
    isStaticModule: false,
    isModuleInRichText: true,
    hasDelegatedBounds: hasDelegatedBounds(item.get('name'))
  }),
  getElementBounds: getElementBoundsWithScrollAndOffsetAndPositionInfo,
  getElements: getStaticOrFlexColumnElement,
  getListFromNodeData: ({
    widgetsInRichText
  }) => {
    return widgetsInRichText || [];
  }
};
export const staticModuleNodePositionConfig = {
  name: STATIC_MODULES_CONFIG,
  getCustomFields: ({
    /* element, index, */item
  }) => ({
    depth: 0,
    id: item.get('name'),
    isModule: true,
    isStaticModule: true,
    isStaticSectionModule: item.get('isStaticSectionModule'),
    hasDelegatedBounds: hasDelegatedBounds(item.get('name'))
  }),
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: getStaticOrFlexColumnElement,
  getListFromNodeData: ({
    allStaticModules
  }) => {
    return allStaticModules || [];
  }
};
export const flexColumnModuleNodePositionConfig = {
  name: FLEX_COLUMN_MODULES_CONFIG,
  getCustomFields: ({
    /* element, index, */item
  }) => ({
    depth: 0,
    id: item.get('name'),
    isModule: true,
    isFlexColumnModule: true,
    hasDelegatedBounds: hasDelegatedBounds(item.get('name'))
  }),
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: getStaticOrFlexColumnElement,
  getListFromNodeData: ({
    allFlexColumnModules
  }) => {
    return allFlexColumnModules || [];
  }
};
const buildGlobalGroupNodePositionConfig = () => ({
  name: GLOBAL_GROUPS_CONFIG,
  getCustomFields: ({
    item,
    index,
    bounds,
    element
  }) => {
    // Bringing back getTallestElementHeight, but only for globals for now
    const tallestHeightData = getTallestElementHeight(element, {
      ignorePositioning: true,
      shouldUseFractionalHeight: true,
      viewportBounds: viewportBoundsForCurrentPass
    });
    return {
      bottom: bounds.top + tallestHeightData.tallestHeight,
      height: tallestHeightData.tallestHeight,
      depth: 0,
      isGlobalGroup: true,
      id: item.path,
      path: item.path,
      index,
      uniquePositionId: `${item.path}-${index}`,
      hasDelegatedBounds: hasDelegatedBounds(item.path)
    };
  },
  // Use uniquePositionId to support multiple globals with the same path
  getPositionLookupId: nodePosition => nodePosition.uniquePositionId,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: globalGroup => {
    if (hasDelegatedBounds(globalGroup.path)) {
      return [getDelegatedBounds(globalGroup.path)];
    } else {
      const queryString = buildGlobalGroupSelector(globalGroup.path);
      return Array.from(document.querySelectorAll(queryString));
    }
  },
  getListFromNodeData: ({
    globalGroups
  }) => globalGroups || []
});
const buildGlobalPartialsNodePositionConfig = () => ({
  name: GLOBAL_PARTIALS_CONFIG,
  getCustomFields: ({
    item,
    index,
    bounds,
    element
  }) => {
    // Bringing back getTallestElementHeight, but only for globals for now
    const tallestHeightData = getTallestElementHeight(element, {
      ignorePositioning: true,
      shouldUseFractionalHeight: true,
      viewportBounds: viewportBoundsForCurrentPass
    });
    const isEmbed = element.hasAttribute('data-embed-id');
    return {
      bottom: bounds.top + tallestHeightData.tallestHeight,
      height: tallestHeightData.tallestHeight,
      depth: 0,
      id: item.path,
      path: item.path,
      index,
      uniquePositionId: `${item.path}-${index}`,
      isGlobalPartial: true,
      hasDelegatedBounds: hasDelegatedBounds(item.path),
      isEmbed
    };
  },
  // Use uniquePositionId to support multiple globals with the same path
  getPositionLookupId: nodePosition => nodePosition.uniquePositionId,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: globalPartial => {
    if (hasDelegatedBounds(globalPartial.path)) {
      return [getDelegatedBounds(globalPartial.path)];
    } else {
      const queryString = buildGlobalPartialSelector(globalPartial.path);
      return Array.from(document.querySelectorAll(queryString));
    }
  },
  getListFromNodeData: ({
    globalPartials
  }) => globalPartials || []
});
const buildHeaderInfoNodePositionConfig = () => ({
  name: HEADER_INFO_CONFIG,
  getCustomFields: ({
    item,
    index,
    bounds,
    element
  }) => {
    // Bringing back getTallestElementHeight, but only for globals for now
    const tallestHeightData = getTallestElementHeight(element, {
      ignorePositioning: true,
      shouldUseFractionalHeight: true,
      viewportBounds: viewportBoundsForCurrentPass
    });
    return {
      bottom: bounds.top + tallestHeightData.tallestHeight,
      height: tallestHeightData.tallestHeight,
      depth: 0,
      id: item.path,
      path: item.path,
      index,
      uniquePositionId: `${item.path}-${index}`,
      isGlobalPartial: true,
      hasDelegatedBounds: hasDelegatedBounds(item.path),
      isEmbed: false,
      isHeader: true,
      isFooter: false
    };
  },
  // Use uniquePositionId to support multiple globals with the same path
  getPositionLookupId: nodePosition => nodePosition.uniquePositionId,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: header => {
    if (hasDelegatedBounds(header.path)) {
      return [getDelegatedBounds(header.path)];
    } else {
      const queryString = buildGlobalPartialSelector(header.path);
      return Array.from(document.querySelectorAll(queryString));
    }
  },
  getListFromNodeData: ({
    headerInfo
  }) => headerInfo || []
});
const buildFooterInfoNodePositionConfig = () => ({
  name: FOOTER_INFO_CONFIG,
  getCustomFields: ({
    item,
    index,
    bounds,
    element
  }) => {
    // Bringing back getTallestElementHeight, but only for globals for now
    const tallestHeightData = getTallestElementHeight(element, {
      ignorePositioning: true,
      shouldUseFractionalHeight: true,
      viewportBounds: viewportBoundsForCurrentPass
    });
    return {
      bottom: bounds.top + tallestHeightData.tallestHeight,
      height: tallestHeightData.tallestHeight,
      depth: 0,
      id: item.path,
      path: item.path,
      index,
      uniquePositionId: `${item.path}-${index}`,
      isGlobalPartial: true,
      hasDelegatedBounds: hasDelegatedBounds(item.path),
      isEmbed: false,
      isFooter: true,
      isHeader: false
    };
  },
  // Use uniquePositionId to support multiple globals with the same path
  getPositionLookupId: nodePosition => nodePosition.uniquePositionId,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: footer => {
    if (hasDelegatedBounds(footer.path)) {
      return [getDelegatedBounds(footer.path)];
    } else {
      const queryString = buildGlobalPartialSelector(footer.path);
      return Array.from(document.querySelectorAll(queryString));
    }
  },
  getListFromNodeData: ({
    footerInfo
  }) => footerInfo || []
});
export const layoutSectionNodePositionConfig = {
  name: LAYOUT_SECTIONS_CONFIG,
  calculateNodePositions: (nodeData, prevNodePositions, config) => {
    const {
      layoutSectionIds,
      layoutSectionIteratorMap
    } = nodeData;
    return calculateLayoutTreeNodePositions(layoutSectionIds, layoutSectionIteratorMap, prevNodePositions, config);
  },
  // Note without this, future incremental bounds checks on the root would be wrong (when scrolled
  // away from the top)
  // TODO, switch this to getElementBoundsWithScrollAndPositionInfo id/when we eventually want to
  // support fixed or absolute position on D&D area stuff (though it will incur some perf hit?)
  getElementBounds: getElementBoundsWithScrollOffset,
  getElements: node => {
    if (hasDelegatedBounds(node.getName())) {
      return [getDelegatedBounds(node.getName())];
    }
    return getLayoutTreeElements(node);
  }
};
export const buildNodePositionsConfig = () => {
  return {
    [POST_BODY_MODULES_CONFIG]: postBodyModuleNodePositionConfig,
    [GLOBAL_GROUPS_CONFIG]: buildGlobalGroupNodePositionConfig(),
    [GLOBAL_PARTIALS_CONFIG]: buildGlobalPartialsNodePositionConfig(),
    [HEADER_INFO_CONFIG]: buildHeaderInfoNodePositionConfig(),
    [FOOTER_INFO_CONFIG]: buildFooterInfoNodePositionConfig(),
    [STATIC_MODULES_CONFIG]: staticModuleNodePositionConfig,
    [FLEX_COLUMN_MODULES_CONFIG]: flexColumnModuleNodePositionConfig,
    [LAYOUT_SECTIONS_CONFIG]: layoutSectionNodePositionConfig
  };
};
export const staticModuleNodePositionConfigDataAuthoring = {
  name: `${STATIC_MODULES_CONFIG}`,
  getCustomFields: ({
    /* element, index, */item
  }) => ({
    depth: 0,
    id: item.get('name'),
    isModule: true,
    isStaticModule: true,
    isStaticSectionModule: item.get('isStaticSectionModule'),
    hasDelegatedBounds: hasDelegatedBounds(item.get('name'))
  }),
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: getStaticOrFlexColumnElementThatContainsStructuredContent,
  getListFromNodeData: ({
    allStaticModules
  }) => {
    return allStaticModules || [];
  }
};
export const flexColumnModuleNodePositionConfigDataAuthoring = {
  name: `${FLEX_COLUMN_MODULES_CONFIG}`,
  getCustomFields: ({
    /* element, index, */item
  }) => ({
    depth: 0,
    id: item.get('name'),
    isModule: true,
    isFlexColumnModule: true,
    hasDelegatedBounds: hasDelegatedBounds(item.get('name'))
  }),
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: getStaticOrFlexColumnElementThatContainsStructuredContent,
  getListFromNodeData: ({
    allFlexColumnModules
  }) => {
    return allFlexColumnModules || [];
  }
};
export const layoutSectionNodePositionConfigDataAuthoring = {
  name: LAYOUT_SECTIONS_CONFIG,
  calculateNodePositions: (nodeData, prevNodePositions, config) => {
    const {
      layoutSectionIds,
      layoutSectionIteratorMap
    } = nodeData;
    return calculateLayoutTreeNodePositions(layoutSectionIds, layoutSectionIteratorMap, prevNodePositions, config);
  },
  // Note without this, future incremental bounds checks on the root would be wrong (when scrolled
  // away from the top)
  // TODO, switch this to getElementBoundsWithScrollAndPositionInfo id/when we eventually want to
  // support fixed or absolute position on D&D area stuff (though it will incur some perf hit?)
  getElementBounds: getElementBoundsWithScrollOffset,
  getElements: node => {
    if (hasDelegatedBounds(node.getName())) {
      return [getDelegatedBounds(node.getName())];
    }
    const elementArray = getLayoutTreeElements(node);
    if (!node.isModule()) {
      return elementArray;
    }
    if (elementArray.length === 0) {
      return elementArray;
    }
    const element = elementArray[0];
    const elementContainsInlineHubDBField = Boolean(element.querySelector('[data-hs-token^="hubdb.dynamic_page_hubdb_row"]'));
    const nodeParams = node.getParams();
    let nodeContainsStructuredContentDataToken = false;
    if (nodeParams && nodeParams.data_tokens) {
      nodeContainsStructuredContentDataToken = Object.values(nodeParams.data_tokens).some(dataToken => dataToken.startsWith('dynamic_page_hubdb_row.'));
    }
    return elementContainsInlineHubDBField || nodeContainsStructuredContentDataToken ? elementArray : [];
  }
};
export const buildNodePositionsConfigForDataAuthoring = () => {
  return {
    [GLOBAL_GROUPS_CONFIG]: buildGlobalGroupNodePositionConfig(),
    [GLOBAL_PARTIALS_CONFIG]: buildGlobalPartialsNodePositionConfig(),
    [HEADER_INFO_CONFIG]: buildHeaderInfoNodePositionConfig(),
    [FOOTER_INFO_CONFIG]: buildFooterInfoNodePositionConfig(),
    [STATIC_MODULES_CONFIG]: staticModuleNodePositionConfigDataAuthoring,
    [FLEX_COLUMN_MODULES_CONFIG]: flexColumnModuleNodePositionConfigDataAuthoring,
    [LAYOUT_SECTIONS_CONFIG]: layoutSectionNodePositionConfigDataAuthoring,
    [NESTED_MODULES_IN_RTE_CONFIG]: nestedModulesInRichTextNodePositionConfig
  };
};
const globalPartialsNodePositionConfigForDistractionFreeMode = {
  name: `${GLOBAL_PARTIALS_CONFIG}`,
  getCustomFields: () => ({}),
  getPositionLookupId: () => null,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: () => [],
  getListFromNodeData: () => []
};
const headerInfoNodePositionConfigForDistractionFreeMode = {
  name: `${HEADER_INFO_CONFIG}`,
  getCustomFields: () => ({}),
  getPositionLookupId: () => null,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: () => [],
  getListFromNodeData: () => []
};
const footerInfoNodePositionConfigForDistractionFreeMode = {
  name: `${FOOTER_INFO_CONFIG}`,
  getCustomFields: () => ({}),
  getPositionLookupId: () => null,
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: () => [],
  getListFromNodeData: () => []
};
const staticModulesNodePositionConfigForDistractionFreeMode = {
  name: `${STATIC_MODULES_CONFIG}`,
  getCustomFields: () => ({}),
  getElementBounds: getElementBoundsWithScrollAndPositionInfo,
  getElements: () => [],
  getListFromNodeData: () => []
};
const layoutSectionNodePositionConfigForDistractionFreeMode = {
  name: `${LAYOUT_SECTIONS_CONFIG}`,
  calculateNodePositions: () => ({}),
  getElementBounds: getElementBoundsWithScrollOffset,
  getElements: () => [],
  getListFromNodeData: () => []
};
export const buildNodePositionsConfigForDistractionFreeMode = () => {
  return {
    [GLOBAL_PARTIALS_CONFIG]: globalPartialsNodePositionConfigForDistractionFreeMode,
    [HEADER_INFO_CONFIG]: headerInfoNodePositionConfigForDistractionFreeMode,
    [FOOTER_INFO_CONFIG]: footerInfoNodePositionConfigForDistractionFreeMode,
    [LAYOUT_SECTIONS_CONFIG]: layoutSectionNodePositionConfigForDistractionFreeMode,
    [POST_BODY_MODULES_CONFIG]: postBodyModuleNodePositionConfig,
    [STATIC_MODULES_CONFIG]: staticModulesNodePositionConfigForDistractionFreeMode
  };
};
const getCalculateGridLayoutsNodePositions = memoize(activeBreakpoint => {
  return (nodeData, previousNodePositions, subConfig) => {
    const {
      gridLayoutIds,
      gridLayoutIteratorMap
    } = nodeData;
    return calculateGridLayoutTreeNodePositions(gridLayoutIds, gridLayoutIteratorMap, previousNodePositions, subConfig, activeBreakpoint);
  };
});
export const getGridLayoutsNodePositionConfig = activeBreakpoint => {
  return {
    name: GRID_LAYOUTS_NODE_POSITION_CONFIG,
    calculateNodePositions: getCalculateGridLayoutsNodePositions(activeBreakpoint),
    // Note without this, future incremental bounds checks on the root would be wrong (when scrolled
    // away from the top)
    // TODO, switch this to getElementBoundsWithScrollAndPositionInfo id/when we eventually want to
    // support fixed or absolute position on D&D area stuff (though it will incur some perf hit?)
    getElementBounds: getElementBoundsWithScrollOffset,
    getElements: getGridLayoutTreeElement
  };
};
export const buildNodePositionConfigForGridLayouts = activeBreakpoint => {
  return {
    [GRID_LAYOUTS_NODE_POSITION_CONFIG]: getGridLayoutsNodePositionConfig(activeBreakpoint),
    [GLOBAL_GROUPS_CONFIG]: buildGlobalGroupNodePositionConfig(),
    [GLOBAL_PARTIALS_CONFIG]: buildGlobalPartialsNodePositionConfig(),
    [HEADER_INFO_CONFIG]: buildHeaderInfoNodePositionConfig(),
    [FOOTER_INFO_CONFIG]: buildFooterInfoNodePositionConfig()
  };
};